export default __webpack_public_path__ + "static/sesoPlaceholder-cc1e66bfda62becf690feed6428f368e.webp";